(function () {
  if (window.__veloraUpsell) return;
  window.__veloraUpsell = true;

  var INSURED = 'insured-shipping';
  var BLURB = 'Protect your order against loss, theft or damage in transit — fast, free replacement.';

  var productPromise = null;
  var lastSig = '';

  function getProduct() {
    if (!productPromise) {
      productPromise = fetch('/products/' + INSURED + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productPromise;
  }

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function cartState() {
    var count = 0, hasInsured = false;
    document.querySelectorAll('.cart-item .cart-item__name').forEach(function (a) {
      count++;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/products/' + INSURED) !== -1) hasInsured = true;
    });
    return { count: count, hasInsured: hasInsured };
  }

  function buildWidget(host, product) {
    var variant = product.variants[0];
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var media = img
      ? '<img class="velora-upsell__img" src="' + img + '" alt="" loading="lazy">'
      : '<span class="velora-upsell__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z"/><path d="m9 12 2 2 4-4"/></svg></span>';

    var w = document.createElement('div');
    w.className = 'velora-upsell';
    w.innerHTML =
      '<div class="velora-upsell__tag">Recommended</div>' +
      '<div class="velora-upsell__row">' +
        media +
        '<div class="velora-upsell__info">' +
          '<div class="velora-upsell__name">Insured Shipping</div>' +
          '<div class="velora-upsell__blurb"></div>' +
          '<div class="velora-upsell__price"><span class="velora-upsell__now">' + money(variant.price) + '</span></div>' +
        '</div>' +
        '<button type="button" class="velora-upsell__btn">Add</button>' +
      '</div>';
    w.querySelector('.velora-upsell__blurb').textContent = BLURB;
    host.appendChild(w);

    var btn = w.querySelector('.velora-upsell__btn');
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      btn.disabled = true; btn.textContent = 'Adding…';
      var inDrawer = !!btn.closest('#CartDrawer');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        try { if (inDrawer) sessionStorage.setItem('velora_open_drawer', '1'); } catch (e2) {}
        window.location.reload();
      }).catch(function () { btn.disabled = false; btn.textContent = 'Add'; });
    });
  }

  function scan() {
    var st = cartState();
    var show = st.count > 0 && !st.hasInsured;
    var sig = st.count + '|' + st.hasInsured;

    if (!show) {
      lastSig = sig;
      document.querySelectorAll('.velora-upsell-host').forEach(function (h) { h.remove(); });
      return;
    }

    if (sig !== lastSig) {
      document.querySelectorAll('.velora-upsell-host').forEach(function (h) { h.remove(); });
      lastSig = sig;
    }

    var targets = [];
    var d = document.querySelector('#CartDrawer-CartItems'); if (d) targets.push(d);
    var c = document.querySelector('#main-cart-items'); if (c) targets.push(c);
    var need = targets.filter(function (t) { return !(t.parentNode && t.parentNode.querySelector('.velora-upsell')); });
    if (need.length === 0) return;

    getProduct().then(function (p) {
      if (!p || !p.variants || !p.variants.length) return;
      need.forEach(function (t) {
        if (t.parentNode.querySelector('.velora-upsell')) return;
        var host = document.createElement('div');
        host.className = 'velora-upsell-host';
        t.parentNode.insertBefore(host, t.nextSibling);
        buildWidget(host, p);
      });
    });
  }

  var sched = false;
  function rescan() { if (sched) return; sched = true; setTimeout(function () { sched = false; scan(); }, 80); }

  function observe() {
    ['#CartDrawer', '#main-cart-items', 'cart-drawer', 'cart-items'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) new MutationObserver(rescan).observe(el, { childList: true, subtree: true });
    });
  }

  function boot() { scan(); observe(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();